import { Controller } from "@hotwired/stimulus";

// Adds and removes rows for a Rails accepts_nested_attributes_for form.
// Reusable for any resource — knows nothing about what a row represents.
//
// Markup contract:
//   - `template` target: a <template> wrapping one row's fields_for output,
//     built with `child_index: "NEW_RECORD"` so field names/ids can be made unique.
//   - `target` target: the element new rows are appended to.
//   - `row` target: the wrapping element for one row (must carry a hidden
//     `[id]` field when persisted, and a hidden `[_destroy]` field).
//
// Events: `nested-fields:removed` fires on the controller element after a row is removed.
//
// Connects to data-controller="nested-fields"
export default class extends Controller {
  static targets = ["target", "template", "row"];

  add(event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());

    this.targetTarget.insertAdjacentHTML("beforeend", content);
  }

  remove(event) {
    event.preventDefault();

    const row = event.target.closest(`[data-${this.identifier}-target="row"]`);
    if (!row) return;

    const idField = row.querySelector("input[name$='[id]']");

    if (idField && idField.value) {
      const destroyField = row.querySelector("input[name$='[_destroy]']");
      if (destroyField) destroyField.value = "1";
      row.hidden = true;
    } else {
      row.remove();
    }

    // Dispatched from the controller element (which stays in the DOM) so listeners
    // still fire after the clicked button's row is gone.
    this.dispatch("removed", { detail: { row } });
  }
}
